import {
  Avatar,
  Button,
  Col,
  Divider,
  Modal,
  Icon,
  Input,
  Layout,
  Menu,
  message,
  Row,
  Select,
  Tooltip,
  Skeleton,
} from "antd";
import React, { Component } from "react";
import MiCompAPI from "../../util/api";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import contact from '../../assets/img/getin.png';
import { createChatThread } from "./ChatandCall";

import moment from "moment";
import AddparticipantsDrawer from "./AddparticipantsDrawer";
import SingleMessages from "./SingleMessages";
import { Collaborationformats, Collaborationmodules } from "./Index";
import SingleMessagesThread from "./SingleMessagesThread";
const { Option } = Select;
const { Search } = Input;


const { Content, Sider, Header, Footer } = Layout;

export default class Collaboration extends Component {
  constructor(props) {
    super(props);
    this.chatThreadClient = null;
    this.userPermandMasters = this.props.userPermandMasters;
    this.state = {
      chattext: "",
      show: false,
      threads: [],
      dthreads: [],
      thread: null,
      messages: [],
      loginuser: this.props.loginuser,
      participants: [],
      typingindicator: null,
      readReceipt: '',
      myLastMessage: "",
      newChat:false
    };

    this.api = new MiCompAPI(this.userPermandMasters);
  }
  updatechatMessages = async (threadId) => {
    setTimeout(async () => {
      let { chatClient } = this.props;
      chatClient.on("readReceiptReceived", async (e) => {
        this.setState({
          readReceipt: 'read'
        })
      });
      let { UserProfileName } = this.userPermandMasters.decodedToken;

      this.chatThreadClient = chatClient.getChatThreadClient(threadId);
      const messages = this.chatThreadClient.listMessages({ maxPageSize: 200 });
      const readreceipts = this.chatThreadClient.listReadReceipts();
      // for await (const readreceipt of readreceipts.next()) {
      const lastmessageread = await readreceipts.next()

      // }

      const lastMessageDetails = await messages.next()
      if (lastMessageDetails.value.type === 'html' && lastMessageDetails.value.senderDisplayName !== UserProfileName) {
        this.chatThreadClient.sendReadReceipt({ chatMessageId: lastMessageDetails.value.id })
      }
      for await (const message of messages.byPage()) {
        const readmessage = message.filter(item => item.senderDisplayName === UserProfileName).shift()
        this.setState({
          messages: [...message],
          readReceipt: readmessage && readmessage.id === lastmessageread.value.chatMessageId ? 'read' : 'sent'
        });
      }
    }, 300);

  };


  componentDidMount() {
    this.getAllContactsofLoggedinUser();

    this.GetallAzureThreads();
    let { chatClient } = this.props;
    if (chatClient) {
      chatClient.startRealtimeNotifications();
      chatClient.on("chatMessageReceived", async (e) => {

        this.chatThreadClient = chatClient.getChatThreadClient(e.threadId);
        this.chatThreadClient.getMessage(e.id).then((x) => {
          this.setState({
            messages: [...this.state.messages, x],
          });
        });
        this.UpdateAzureThreads(e.threadId);
        if (this.state.thread && e.threadId === this.state.thread.threadId) {
          this.chatThreadClient.sendReadReceipt({ chatMessageId: e.id });
        }
      });
      chatClient.on("chatMessageEdited", async (e) => {
        this.chatThreadClient = chatClient.getChatThreadClient(e.threadId);
        this.setState({
          messages: [...this.state.messages.map(x => {
            if (x.id === e.id)
              return { ...x, content: { ...x.content, message: e.message } }
            else
              return x

          })],
        });
        this.UpdateAzureThreads(e.threadId);
      });
      chatClient.on("chatMessageDeleted", async (e) => {
        this.chatThreadClient = chatClient.getChatThreadClient(e.threadId);
        this.setState({
          messages: [...this.state.messages.filter(x => x.id !== e.id)],
        }); this.UpdateAzureThreads(e.threadId);
      });
      // chatClient.on("typingIndicatorReceived", async (e) => {
      //   this.setState({
      //     typingindicator: e,
      //   });
      // });


      chatClient.on("chatThreadCreated", async () => {
        this.GetallAzureThreads();
      });
      chatClient.on("chatThreadDeleted", async () => {
        this.GetallAzureThreads();
      });
      chatClient.on("chatThreadPropertiesUpdated", async () => {
        this.GetallAzureThreads();
      });
      chatClient.on("participantsRemoved", async () => {
        this.GetallAzureThreads();
      });
    }

  }


  getAllContactsofLoggedinUser() {
    this.api.invoke("getAllContactsofLoggedinUser", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const users = data.data;

          this.setState({ participants: users });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  UpdateAzureThreads(threadId) {
    this.api.invoke(
      "UpdateAzureThreads/" + threadId,
      "patch",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetallAzureThreads(threadId);

          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  DeleteAzureThreads(val) {
    let { chatClient } = this.props;

    this.api.invoke(
      "DeleteAzureThreads/" + val.threadId,
      "delete",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            chatClient.deleteChatThread(val.threadId);
            this.GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  }
  ContentModeration() {
    if (!this.state.chattext || this.state.chattext.trim() === "") {
      message.destroy();
      message.info("Please type a message to continue", 3)
      return;
    }
    this.setState({
      readReceipt: 'post'
    })
    // this.api.invoke(
    //   "ContentModeration",
    //   "post",
    //   (data, success) => {
    //     if (success) {
    //       if (data.statusCode === 200) {

    //         if (!data.data) {

    var userProfileName = this.userPermandMasters.decodedToken.UserProfileName;
    const sendMessageRequest = {
      content: this.state.chattext,
    };
    let sendMessageOptions = {
      senderDisplayName: userProfileName,
      type: "html",
    };

    this.chatThreadClient
      .sendMessage(sendMessageRequest, sendMessageOptions)
      .then((e) => {

        this.UpdateAzureThreads(this.state.thread.threadId);
        this.setState({
          chattext: "",
        });
      }, (error) => {
        this.setState({
          readReceipt: 'failed'
        })
      });
    //         } else {
    //           message.destroy();
    //           message.warning(data.statusMessage, 3);
    //         }
    //       } else {
    //         message.destroy();
    //         message.error(data.statusMessage, 3);
    //       }
    //     }
    //   }, { id: 0, value: this.state.chattext }
    // );
  }
  GetallAzureThreads() {
    this.api.invoke("GetallAzureThreads", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            threads: data.data,
            dthreads: data.data
          });
          if (data.data && data.data.length > 0) {
            if (this.state.thread === null) {
              this.setState({
                thread: data.data[0],
              });
              this.updatechatMessages(data.data[0].threadId);
            } else {
              this.setState({
                thread: this.state.thread,
                readReceipt: 'sent'
              });
              this.updatechatMessages(this.state.thread.threadId);
            }
          } else {
            this.setState({
              thread: null,
              messages: [],
            });
          }
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  SaveAzureThreads(data) {
    this.api.invoke(
      "SaveAzureThreads",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  AddParticipants(data) {
    this.api.invoke(
      "AddParticipants",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  RemoveParticipants(data) {
    this.api.invoke(
      "RemoveParticipants",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }

  CreateThread = (e) => {
    let { chatClient, GetUserTokenandIdentitybyId } = this.props;

    GetUserTokenandIdentitybyId(e, (chatuser) => {
      if (chatuser) {
        let user = this.state.participants.find((x) => x.userId === e);
        setTimeout(() => {
          let participants = [
            {
              id: { communicationUserId: chatuser.userIdentity },
              displayName: user && user.name //+ "(" + user.role + ")",
            },
          ];
          let { UserProfileName, UserRoleName, UserId } = this.userPermandMasters.decodedToken;
          let thread = this.state.threads.find(
            (x) => x.participants.length === 1 &&
              x.participants.filter((a) => a.userid === user.userId).length ===
              1
          );

          if (thread) {
            this.setState({
              thread: thread,
              newChat:false
            });
            this.chatThreadClient = chatClient.getChatThreadClient(thread.threadId);
          } else {
            createChatThread(
              user && user.name, //+ "(" + user.role + ")",
              participants,
              chatClient
            ).then((threadId) => {
              this.chatThreadClient = chatClient.getChatThreadClient(threadId);
              this.setState({
                newChat:false,
                thread: {
                  threadId: threadId,
                  participants: [
                    {
                      userid: user.userId,
                      name: user.name,
                      role: user.role,
                      email: user.email,
                      communicationUserId: chatuser.userIdentity,
                    },
                  ],
                },
              });
              this.SaveAzureThreads({
                threadId: threadId,
                participants: [
                  {
                    userid: UserId,
                    name: UserProfileName,
                    role: UserRoleName,
                    email: this.state.loginuser.Email,
                    communicationUserId: this.state.loginuser.userIdentity,
                  },
                  {
                    userid: user.userId,
                    name: user.name,
                    role: user.role,
                    email: user.email,
                    communicationUserId: chatuser.userIdentity,
                  },
                ],
              });
            });
          }
        }, 100);
      }
    });
  };
  AddparticipantsCallBack(Users, participants, data, callback) {
    // eslint-disable-next-line array-callback-return
    let { GetUserTokenandIdentitybyId } = this.props;

    data.forEach((a) => {
      GetUserTokenandIdentitybyId(a, (chatuser) => {
        if (chatuser) {
          let user = this.state.participants.find((x) => x.userId === a);
          participants.push({
            id: { communicationUserId: chatuser.userIdentity },
            displayName: user && user.name //+ "(" + user.role + ")",
          });
          Users.push({
            userid: user.userId,
            name: user.name,
            role: user.role,
            email: user.email,
            communicationUserId: chatuser.userIdentity,
          });
        }
        return 10;
      });
    });
    callback(Users, participants);
  }
  AddparticipantsSubmitHandler = (data) => {
    const { UserId, UserProfileName, UserRoleName } = this.userPermandMasters.decodedToken;
    if (this.state.thread.participants.length === 1) {
      this.AddparticipantsCallBack(
        [
          {
            userid: UserId,
            name: UserProfileName,
            role: UserRoleName,
            email: this.state.loginuser.Email,
            communicationUserId: this.state.loginuser.userIdentity,
          },
          ...this.state.thread.participants,
        ],
        [
          ...this.state.thread.participants.map((a) => {
            let user = this.state.participants.find((x) => x.userId === a.userId);
            return {
              id: { communicationUserId: a.communicationUserId },
              displayName: user && user.name //+ "(" + user.role + ")",

            };
          }),
        ],
        data.participants,
        (Users, participants) => {
          let { chatClient } = this.props;

          setTimeout(() => {
            createChatThread(
              UserProfileName,
              participants,
              chatClient
            ).then((threadId) => {
              this.SaveAzureThreads({
                threadId: threadId,
                participants: Users,
              });
              this.setState({
                show: false,
              });
            });
          }, 1000);
        }
      );
    } else {
      this.AddparticipantsCallBack(
        [],
        [],
        data.participants,
        (Users, participants) => {
          setTimeout(() => {
            this.chatThreadClient
              .addParticipants({ participants: participants })
              .then(() => {
                this.AddParticipants({
                  threadId: this.state.thread.threadId,
                  participants: Users,
                });
                this.setState({
                  show: false,
                });
              });
          }, 1000);
        }
      );
    }
  };
  listMessages = async (data) => {
    this.setState({
      thread: data,
      newChat:false
    });
    this.updatechatMessages(data.threadId);
  };
  filterBySearch = (event) => {
    const query = event.target.value;
    let data = this.state.dthreads.filter((item) => {
      return item.participants.find(x => x.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    });
    this.updatechatMessages(data[0].threadId);
    if (data)
      this.setState({ threads: data });
  };
  messageGrouping(list) {
    return list.reduce((groups, item) => {
      let data = moment(item.createdOn).format("MMDDYYYY");
      const createdOn = (groups[data] || []);
      createdOn.push(item);
      groups[data] = createdOn;
      return groups;
    }, {});
  }


  render() {
    let { placeCall } = this.props;
    const { UserId, UserProfileName, UserRoleName } = this.userPermandMasters.decodedToken;
    return (
      <Content style={{ background: "#fff", margin: "5px" }}>

        {this.state.show && (
          <Modal visible={this.state.show}>
            <AddparticipantsDrawer
              closeDrawerHandler={() => {
                this.setState({
                  show: false,
                });
              }}
              submitHandler={this.AddparticipantsSubmitHandler}
              width={500}
              participants={this.state.participants.filter(
                (x) =>
                  x.userId !== UserId &&
                  !this.state.thread.participants.find(
                    (a) => a.userid === x.userId
                  )
              )}
              userPermandMasters={this.userPermandMasters}
            />
          </Modal>
        )}



        <Layout style={{ background: "#fff" }}>
          <Sider
            width={300}
            className="collabration_sider"
            style={{
              backgroundColor: "#fff",
              // overflow: "auto",
              // height: "90vh",
            }}
          >
            <Row style={{display:"flex",justifyContent:"center",alignItems:"center", height:49,boxShadow: "0px 0px 10px rgb(229 229 229) ",marginBottom:11}}>
              <Col span={19} style={{fontWeight:"500",color:"black"}}>
              Messages (30)
              </Col>
              <Col span={1} className="collab_icon">
              <i className="fa fa-pencil-square-o" style={{color:"black",fontSize: "20px !important"}} aria-hidden="true" onClick={()=>{this.setState({newChat:true})}}></i>
              </Col>
            </Row>
            <Search
              style={{ paddingLeft: 18 ,border: "1px solid #e8e8e8",borderRadius: 8,width: 280,marginLeft: 8,marginBottom: 3}}
              placeholder="Search"
              onChange={this.filterBySearch}
            />
            <Menu mode="inline" defaultSelectedKeys={["0"]} triggerSubMenuAction="click">
              {this.state.threads.map((item, inx) => {
                return (<Menu.Item key={inx}
                  onClick={() => {
                    this.listMessages(item)

                  }}
                ><SingleMessagesThread chatClient={this.props.chatClient} item={item} DeleteAzureThreads={() => { this.DeleteAzureThreads(item) }}
                  RemoveParticipants={() => {

                    this.chatThreadClient
                      .removeParticipant({
                        communicationUserId:
                          this.state.loginuser
                            .userIdentity,
                      })
                      .then(() => {
                        this.RemoveParticipants({
                          threadId:
                            item.threadId,
                          participants: [
                            {
                              userid:
                                UserId,
                              name: UserProfileName,
                              role: UserRoleName,
                              email:
                                this.state.loginuser
                                  .email,
                              communicationUserId:
                                this.state.loginuser
                                  .userIdentity,
                            },
                          ],
                        });
                      });
                  }}></SingleMessagesThread></Menu.Item>
                );
              })}
            </Menu>
          </Sider>

          <Layout>
            <Header style={{ background: "#fff",padding:"0px" }}>
              <Row
                span={24}
                style={{
                  marginTop: "-10px",
                  paddingLeft: "10px",
                  height: "60px",
                  boxShadow: "0px 0px 10px rgb(229 229 229) ",
                }}
              >
               {!this.state.newChat? <>
                <Col span={19}>
                  {this.state.thread && (
                    <Tooltip
                      placement="topLeft"
                      title={
                        this.state.thread.participants.length === 1
                          ? this.state.thread.participants[0].name
                          : this.state.thread.participants.map((x, index) => {
                            return (
                              x.name +
                              (this.state.thread.participants.length - 1 !==
                                index
                                ? ", "
                                : "")
                            );
                          })
                      }
                    >
                      <h2 style={{ paddingLeft: "5px" }}>
                        {" "}
                        <Avatar style={{ backgroundColor: "#4e5694" }}>
                          {this.state.thread.participants.length === 1 ? (
                            this.state.thread.participants[0].name
                              .split(" ")
                              .map((item) => item.charAt(0))
                              .join("")
                              .toUpperCase()
                          ) : (
                            <Row span={24}>
                              {" "}
                              {this.state.thread.participants.map((x, inx) => {
                                return (
                                  <Col span={12} key={inx}>
                                    {x.name.charAt(0).toUpperCase()}
                                  </Col>
                                );
                              })}
                            </Row>
                          )}
                        </Avatar>
                        <span style={{ fontSize: "15px", paddingLeft: "10px" }}>
                          {this.state.thread.participants.length === 1
                            ? this.state.thread.participants[0].name
                            : this.state.thread.participants.map((x, index) => {
                              if (index < 2) {
                                return (
                                  x.name.split(" ")[0] +
                                  (this.state.thread.participants.length -
                                    1 !==
                                    index
                                    ? ", "
                                    : "")
                                );
                              } else {
                                if (index > 2) {
                                  return "";
                                }
                                return (
                                  "+" +
                                  (this.state.thread.participants.length - 2)
                                );
                              }
                            })}
                        </span>{" "}
                      </h2>
                    </Tooltip>
                  )}
                </Col>
                {this.state.thread && (
                  <>
                    {this.state.thread &&
                      this.state.thread.participants.length === 1 && (
                        <Col span={1}></Col>
                      )}
                    <Col span={1}>
                      <i
                        onClick={() =>
                          this.setState({
                            show: !this.state.show,
                          })
                        }
                        className="fa fa-user-plus"
                        aria-hidden="true"
                        style={{
                          color: this.state.show ? "black" : "blue",
                          marginTop: "28px",
                        }}
                      ></i>
                    </Col>
                    <Col span={1}>
                      <i
                        onClick={() => {
                          placeCall(this.state.thread.participants.map((x) => {
                            return { communicationUserId: x.communicationUserId };
                          }), false, this.state.thread);
                        }}
                        className="fa fa-phone"
                        aria-hidden="true"
                        style={{ color: "#52c41a", marginTop: "28px" }}
                      ></i>
                    </Col>

                    <Col span={1}>
                      <i
                        onClick={() => {
                          placeCall(this.state.thread.participants.map((x) => {
                            return { communicationUserId: x.communicationUserId };
                          }), true);
                        }}
                        className="fa fa-video-camera"
                        aria-hidden="true"
                        style={{ color: "#4e5694", marginTop: "28px" }}
                      ></i>
                    </Col>
                    {this.state.thread &&
                      this.state.thread.participants.length > 1 && (
                        <Col span={1}>
                          <i
                            onClick={() => {

                              this.chatThreadClient
                                .removeParticipant({
                                  communicationUserId:
                                    this.state.loginuser.userIdentity,
                                })
                                .then(() => {
                                  this.RemoveParticipants({
                                    threadId: this.state.thread.threadId,
                                    participants: [
                                      {
                                        userid: UserId,
                                        name: UserProfileName,
                                        role: UserRoleName,
                                        email: this.state.loginuser.email,
                                        communicationUserId:
                                          this.state.loginuser.userIdentity,
                                      },
                                    ],
                                  });
                                });
                            }}
                            className="fa fa-sign-out"
                            aria-hidden="true"
                            style={{ color: "black", marginTop: "28px" }}
                          ></i>
                        </Col>
                      )}

                    <Col span={1}>
                      <i
                        onClick={() => {
                          this.DeleteAzureThreads(this.state.thread);
                        }}
                        className="fa fa-trash"
                        aria-hidden="true"
                        style={{ color: " #cf1322", marginTop: "28px" }}
                      ></i>
                    </Col>
                  </>
                )}
                </>:<div style={{padding:"2px 10px"}}><Select
                
                // suffixIcon={<Icon type="search" />}
                className="mi_input"
                optionFilterProp="children"
                showSearch={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={this.CreateThread}
                placeholder="Search"
              >
                {this.state.participants
                  ? this.state.participants.map((tag) => (
                    <Option value={tag.userId} key={tag.name}>
                      {tag.name}
                    </Option>
                  ))
                  : ""}
              </Select></div>}
              </Row>
            </Header>

            <Content
              style={{
                background: "#fff",
                paddingLeft: "50px",
                paddingTop: "50px",
                // paddingRight: "50px",
              }}
            >
            {this.state.newChat? <div style={{display:"flex",flexDirection:"column",alignItems:"center",marginTop:-50}}><img className='ant-login-image' alt="example" style={{ width: 450, margin: '0', height: 430 }} src={contact} />
            <p style={{fontWeight:"600",fontSize:16}}>You're starting a new conversation</p>
            <p>Type your first message below.</p>
            </div>: <Content
                style={{
                  overflow: "auto",
                  height: "50vh",
                  paddingRight: "50px",
                  marginTop: "-5px",
                  display:"flex",
                  flexDirection:"column-reverse"
                }}
              >
                {this.state.messages && this.state.messages.length > 0 ? <>
                  {Object.keys(this.messageGrouping(this.state.messages))
                    .map((key, inx) => {
                      return <div key={inx} >
                        <Divider className="ant-divider-with-text">{moment(key, "MMDDYYYY").format("DD")} {moment(key, "MMDDYYYY").format("MMMM")} {moment(new Date()).diff(moment(key, "MMDDYYYY"), 'years') > 0 && moment(key, "MMDDYYYY").format("yyyy")}</Divider>
                        {this.messageGrouping(this.state.messages)[key].sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn)).map((x, i) => {
                          if (x.type === "html" && x.content && x.content.message)
                            return (
                              <>

                                <Row key={i}>

                                  {x.content &&
                                    x.content.message &&
                                    x.senderDisplayName ===
                                    UserProfileName ?
                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "end", width: "99%" }}>
                                      <SingleMessages
                                        userPermandMasters={this.userPermandMasters}
                                        key={x.id}
                                        id={x.id}
                                        createdOn={x.createdOn}
                                        message={x.content && x.content.message}
                                        chatThreadClient={this.chatThreadClient}
                                      > </SingleMessages>
                                      {this.state.messages.filter(item => item.senderDisplayName === UserProfileName).length > 0 ? <div style={{ marginLeft:5}}>
                                        {x.id === this.state.messages.filter(item => item.senderDisplayName === UserProfileName).shift().id ? <span>{this.state.readReceipt === "read" ? <i className="fa fa-eye" style={{ color: "#4e5694" }} aria-hidden="true"></i> : this.state.readReceipt === "post" ? <i className="fa fa-circle-o" style={{ color: "#4e5694" }} aria-hidden="true"></i> : <i className="fa fa-check-circle-o" style={{ color: "#4e5694" }} aria-hidden="true"></i>}</span> : <></>}
                                      </div> : <></>}
                                    </div>
                                    : (

                                      <div style={{
                                        display: "flex",
                                        alignItems: "baseline",
                                      }}>
                                 
                                            <Tooltip
                                              placement="topLeft"
                                              title={
                                                this.state.thread.participants.length === 1
                                                  ? this.state.thread.participants[0].name
                                                  : this.state.thread.participants.map((x, index) => {
                                                    return (
                                                      x.name +
                                                      (this.state.thread.participants.length - 1 !==
                                                        index
                                                        ? ", "
                                                        : "")
                                                    );
                                                  })
                                              }
                                            >
                                              <h2 style={{ paddingLeft: "5px" }}>
                                                {" "}
                                                <Avatar style={{ backgroundColor: "#4e5694" }}>
                                                  {this.state.thread.participants.length === 1 ? (
                                                    x.senderDisplayName
                                                      .split(" ")
                                                      .map((item) => item.charAt(0))
                                                      .join("")
                                                      .toUpperCase()
                                                  ) : (
                                                    <Row span={24}>
                                                      {" "}
                                                      {this.state.thread.participants.map((x, inx) => {
                                                        console.log(x)
                                                        return (
                                                          <Col span={12} key={inx}>
                                                            {x.name.charAt(0).toUpperCase()}
                                                          </Col>
                                                        );
                                                      })}
                                                    </Row>
                                                  )}
                                                </Avatar>

                                              </h2>
                                            </Tooltip>
                                         
                                            <div
                                              key={x.id}
                                              span={24}
                                              style={{
                                                borderRadius: "10px",
                                                // backgroundColor: "#e0dee7",
                                              
                                                padding: "10px",
                                                marginBottom: "4px",
                                                marginTop: "4px",
                                                marginLeft: "5px",
                                                maxWidth: "50%",
                                                boxShadow: "0px 0px 0px 1px #d9d9d9",
                                                width: "fit-content",
                                                minWidth: "200px",
                                              }}
                                            >
                                                <div style={{  display:"flex",justifyContent:"space-between"}}>

                                                    <span style={{ fontSize: "15px",marginRight:10}}>
                                                      {this.state.thread.participants.length === 1
                                                        ? this.state.thread.participants[0].name
                                                        : this.state.thread.participants.map((x, index) => {
                                                          if (index < 2) {
                                                            return (
                                                              x.name.split(" ")[0] +
                                                              (this.state.thread.participants.length -
                                                                1 !==
                                                                index
                                                                ? ", "
                                                                : "")
                                                            );
                                                          } else {
                                                            if (index > 2) {
                                                               return "";
                                                            }
                                                            return (
                                                              "+" +
                                                              (this.state.thread.participants.length - 2)
                                                            );
                                                          }
                                                        })}
                                                    </span>
                                                    
                                                      {moment().diff(moment(x.createdOn), "hour") <= 12
                                                        ?<p> {moment(x.createdOn).format("LT")}</p>
                                                        :<p>{moment(x.createdOn).format("LT")} {moment(x.createdOn, "MMDDYYYY").format("DD")}{`-${moment(x.createdOn, "MMDDYYYY").format("MM")}`}{moment(new Date()).diff(moment(x.createdOn, "MMDDYYYY"), 'years') > 0 && `-${moment(x.createdOn, "MMDDYYYY").format("yyyy")}`}
                                                        </p> }
                                                </div>
                                                <div style={{ marginLeft: "1px", overflowWrap: "break-word", width: "100%",marginBottom:"-16px" }} dangerouslySetInnerHTML={{
                                                  __html: x.content && x.content.message,
                                                }}>
                                              </div>

                                              {/* <Col style={{ marginLeft: "1px", overflowWrap: "break-word", width: "100%", }}
                                                dangerouslySetInnerHTML={{
                                                  __html: x.content && x.content.message,
                                                }}
                                              ></Col> */}
                                            </div>
                                             
                                      </div>
                                    )}
                                </Row>
                              </>
                            );
                        }
                        )}
                      </div>

                    })}
                </> : <><div style={{ width: '300px', margin: '50px Auto', textAlign: 'center' }}>
                  <Skeleton avatar paragraph={{ rows: 2 }} />
                  <Skeleton avatar paragraph={{ rows: 3 }} />
                  <Skeleton avatar paragraph={{ rows: 3 }} />
                  <Skeleton avatar paragraph={{ rows: 3 }} />
                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>You're starting a new conversation</p>
                  <p style={{ fontSize: '18px' }}>Type your first message below.</p>
                </div></>}
              </Content>}
            </Content>

            <Footer className="cl" style={{ background: "#fff" }}>
              {this.state.typingindicator &&
                this.state.typingindicator.threadId ===
                this.state.thread.threadId
                && this.state.loginuser && this.state.typingindicator.sender.communicationUserId !== this.state.loginuser.userIdentity
                && (<p>
                  {this.state.typingindicator.senderDisplayName +
                    " Typing...."}
                </p>
                )}
              <Row span={24}>


                <ReactQuill
                  className="ql-toolbar.ql-snow .ql-container.ql-snow"
                  onKeyUp={() => {
                    this.chatThreadClient.sendTypingNotification({
                      senderDisplayName: UserProfileName,
                    });
                  }}
                  onKeyDown={() => {
                    this.setState({
                      typingindicator: null,
                    });
                  }}
                  onMouseLeave={() => {
                    this.setState({
                      typingindicator: null,
                    });
                  }}
                  value={this.state.chattext}
                  onChange={(input) => {
                    this.setState({
                      chattext: input,
                      style: "border-radius: 100px;",
                    });
                  }}
                  placeholder={"Text your message"}
                  modules={Collaborationmodules}
                  formats={Collaborationformats}
                />

              </Row>

              <Row span={24} style={{ marginTop: "20px" }}>


                <Button
                  style={{
                    float: "right",
                    backgroundColor: "darkslateblue",
                    color: "white",
                    marginTop: "-10px",
                    width: "70px",
                    marginRight: "0px",
                  }}
                  onClick={() => {
                    this.ContentModeration();
                  }}
                >
                  Send
                </Button>
              </Row>
            </Footer>
          </Layout>
        </Layout>
      </Content>
    );
  }
}

